import api from "api";
import { getCurrentUserRole, isExternalMedrep, THIRD_PARTY_MEDREPS } from "modules/utilities/utility";
import { voitekkUserIdMap } from "modules/utilities/voitekkUSerIdMap";
import secureLocalStorage from "react-secure-storage";

export default function changeStatus(status) {
  return api.put(`setLog?status=${status}`);
}

export function notification() {
  return api.get("web-push/notifications");
}

export function globalSearch(data) {
  const apiEndpoint = ["medrep_ext"].includes(getCurrentUserRole())
    ? `caseSearchV2?key=${encodeURIComponent(data)}`
    : `caseSearchV2?key=${encodeURIComponent(data)}`;
  return api.get(apiEndpoint);
}

export function setting() {
  return api.get("settings");
}

export function createTicket(objData, isMedicalSLot) {
  return api.post(`create-ticket?isMedicalSLot=${isMedicalSLot}`, objData);
}

export function assignTo(data) {
  return api.get(`get-assignee-setting?settingKey=${data}`);
}

export function uploadImage(data, ticketId) {
  return api.put(`ticket/${ticketId}/upload`, data);
}

export function getCaseData(id) {
  const apiEndpoint = isExternalMedrep
    ? `v2/case/${id}`
    : `case/${id}`;
  return api.get(apiEndpoint);
}

export function getUserProfile() {
  return api.get(`user/${secureLocalStorage.getItem("id")}/profile`);
}

export function updateProfileData(id, profileData) {
  return api.put(`user/${id}/profile`, profileData);
}

export function removeProfilePicture() {
  return api.delete(`user/deleteProfileImage`);
}

export const getAgentCallingData = ()=>{
  return api.get(`api/authDashboard//slot-booking-comp-audit`);
}

export const getAgentFeedback = () =>{
  return api.get(`agent-feedback-rating`);
}

export function updateUserMeta(meta) {
  return api.patch('user/meta', meta);
}